import React from 'react';
import { Outlet } from 'react-router-dom';
import { authService } from '@/services/auth-service';
import { UnauthenticatedError } from './UnauthenticatedError';

export function ProtectedRoute(): JSX.Element {
  const authed = authService.isAuthenticated();
  if (!authed) {
    return <UnauthenticatedError />;
  }
  return <Outlet />;
}
